import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import reports from './report'
import billing from "./billing";
import waviot_store from "./waviot";
import transport_logs from "./transport/log";
import transport_sber from "./transport/sber";
import transport_ikom from "./transport/ikom";
import transport_ikom_ttu from "./transport/ikom-ttu";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        no_reply_mail: 'no-reply@vc.tom.ru'
    },
    getters: {
        get_no_reply_mail(state) {
            return state.no_reply_mail
        },
    },
    mutations: {},
    actions: {},
    modules: {
        auth,
        reports,
        billing,
        waviot_store,
        transport_logs,
        transport_sber,
        transport_ikom,
        transport_ikom_ttu
    }
})
